import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import HKVDialog from "../../HKVDialog/7.0"

import {
  Button,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material"

import { addLocalStorage } from "../../../store/reducers/localStorage"

import { getAnalyticsId } from "../../../store/environment"

function HKVAnalytics() {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const localStorage = useSelector((state) => state.localStorage)

  const [dialogConfig, setDialogConfig] = useState()

  useEffect(() => {
    const analyticsId = getAnalyticsId()

    switch (localStorage?.consentAnalytics) {
      case "true":
        const script1 = document.createElement("script")
        script1.async = true
        script1.src = `https://www.googletagmanager.com/gtag/js?id=G-${analyticsId}`
        document.head.appendChild(script1)

        const script2 = document.createElement("script")
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || []
          function gtag(){ dataLayer.push(arguments) }
          gtag('js', new Date())
          gtag('config', 'G-${analyticsId}')
        `
        document.head.appendChild(script2)
        break;

      case "false":
        break;

      default:
        openDialog("xs")
        break;
    }
  }, [localStorage?.consentAnalytics])

  useEffect(() => {
    const handler = () => openDialog("xs")
    window.addEventListener("hkv-open-cookie-settings", handler)
    return () => window.removeEventListener("hkv-open-cookie-settings", handler)
  }, [])

  const openDialog = (size, options) => {
    const mergedOptions = { ...options, open: true, size: size ? size : "lg" }
    setDialogConfig(mergedOptions)
  }

  const closeDialog = (accepted = true) => {
    dispatch(addLocalStorage({ key: "consentAnalytics", value: accepted.toString() }))
    setDialogConfig()
  }

  return (
    <HKVDialog
      config={dialogConfig}
      onClose={() => closeDialog(false)}
    >
      <DialogTitle>
        {t("Cookies")}
        <img
          src="/static/images/loader_analytics_consent.gif"
          title={t("Cookies")}
          alt={t("Cookies")}
          width={32} height={32}
          style={{ objectFit: "contain", verticalAlign: "middle" }}
        />
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
        <Typography sx={{ whiteSpace: "pre-line" }}>{t("Cookie_text")}</Typography>
        <div className="dialog-actions">
          <Typography
            variant="caption"
            sx={{ margin: "auto auto auto 0" }}
          >
            {/* claude: opent de interne Privacy-dialoog (App.js) via een event i.p.v. door te linken naar hkv.nl */}
            <a
              title={t("Privacy_statement")}
              href="#privacy"
              onClick={(e) => {
                e.preventDefault()
                window.dispatchEvent(new Event("hkv-open-privacy-dialog"))
              }}
            >
              {t("Privacy_statement")}
            </a>
          </Typography>
          <Button
            variant="outlined"
            color="error"
            className="dialog-button"
            onClick={() => closeDialog(false)}
          >
            {t("Deny")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className="dialog-button"
            onClick={() => closeDialog(true)}
          >
            {t("Accept")}
          </Button>
        </div>
      </DialogContent>
    </HKVDialog>
  )
}

export default HKVAnalytics